import { render, staticRenderFns } from "./MembershipTierUpgradeModal.vue?vue&type=template&id=5fe9f522&scoped=true&"
import script from "./MembershipTierUpgradeModal.vue?vue&type=script&lang=ts&"
export * from "./MembershipTierUpgradeModal.vue?vue&type=script&lang=ts&"
import style0 from "./MembershipTierUpgradeModal.vue?vue&type=style&index=0&id=5fe9f522&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe9f522",
  null
  
)

export default component.exports